import { collection, doc, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase";

const col = collection(db, "caseStudies");

/**
 * Public, unauthenticated subscription to published case studies.
 *
 * IMPORTANT: the `where("published", "==", true)` clause is required —
 * Firestore rules are not filters. Listing the whole collection as a guest
 * is rejected outright; the query itself must prove it only touches
 * published docs. Sorting happens client-side so docs without an `order`
 * field still show up (orderBy would silently drop them) and no composite
 * index is needed.
 */
export const subscribePublishedCaseStudies = (cb) =>
  onSnapshot(
    query(col, where("published", "==", true)),
    (snap) => {
      const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      rows.sort((a, b) => {
        const ao = a.order ?? Number.POSITIVE_INFINITY;
        const bo = b.order ?? Number.POSITIVE_INFINITY;
        if (ao !== bo) return ao - bo;
        const at = a.createdAt?.toMillis?.() || 0;
        const bt = b.createdAt?.toMillis?.() || 0;
        return bt - at;
      });
      cb(rows);
    },
    (err) => {
      console.warn("[caseStudies] public list error", err);
      cb([]);
    }
  );

/** Single published case study. Unpublished/missing docs resolve to null. */
export const subscribePublishedCaseStudy = (id, cb) =>
  onSnapshot(
    doc(col, id),
    (snap) =>
      cb(snap.exists() ? { id: snap.id, ...snap.data() } : null),
    (err) => {
      // Guests hitting an unpublished doc land here (permission-denied).
      console.warn("[caseStudies] public doc error", err);
      cb(null);
    }
  );
